import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Drawer, Segmented, Typography, Descriptions, Alert, Empty } from 'antd';
import { QuestionCircleOutlined, FileWordOutlined, PlayCircleOutlined } from '@ant-design/icons';
import help from '../help/help.json';

const { Title, Paragraph } = Typography;

export const videoSlug = (key) => key.replace(/^\//, '').replace(/[/#]/g, '-');

const findScreen = (path) => {
  let best = null;
  help.screens.forEach((s) => {
    if ((path === s.key || path.startsWith(`${s.key}/`)) && (!best || s.key.length > best.key.length)) best = s;
  });
  return best;
};

const LABELS = {
  en: { enter: 'Who enters', approve: 'Who approves', steps: 'Steps', flow: 'Where this fits', video: 'Video', guide: 'Full user guide (Word)', chain: 'Video: the full purchase-to-horse chain', none: 'No help for this screen yet.' },
  ar: { enter: 'من يُدخل', approve: 'من يعتمد', steps: 'الخطوات', flow: 'موقع الشاشة في الدورة', video: 'فيديو', guide: 'دليل المستخدم الكامل (Word)', chain: 'فيديو: سلسلة الشراء إلى الحصان كاملة', none: 'لا توجد مساعدة لهذه الشاشة بعد.' },
};

const HelpButton = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem('helpLang') || 'en');
  const [noVideo, setNoVideo] = useState({});
  const screen = findScreen(pathname);
  const L = LABELS[lang];
  const rtl = lang === 'ar';
  const showFlow = screen && ['Inventory', 'Yard management'].includes(screen.group);

  const changeLang = (v) => { setLang(v); localStorage.setItem('helpLang', v); };

  return (
    <>
      <Button size="small" icon={<QuestionCircleOutlined />} onClick={() => setOpen(true)}>Help</Button>
      <Drawer open={open} onClose={() => setOpen(false)} width={600} title={screen ? screen.title[lang] : 'Help'}
        extra={<Segmented size="small" value={lang} onChange={changeLang} options={[{ value: 'en', label: 'English' }, { value: 'ar', label: 'عربي' }]} />}>
        <div dir={rtl ? 'rtl' : 'ltr'} style={{ textAlign: rtl ? 'right' : 'left' }}>
          {!screen && <Empty description={L.none} />}
          {screen && (
            <>
              <Paragraph style={{ fontSize: 15 }}>{screen.purpose[lang]}</Paragraph>
              {!noVideo[screen.key] && (
                <>
                  <Title level={5}>{L.video}</Title>
                  <video key={screen.key} controls style={{ width: '100%', borderRadius: 6, border: '1px solid #eee', marginBottom: 12 }}
                    src={`/help-videos/${videoSlug(screen.key)}.mp4`} onError={() => setNoVideo((n) => ({ ...n, [screen.key]: true }))} />
                </>
              )}
              <Title level={5}>{L.steps}</Title>
              <ol style={{ paddingInlineStart: 20 }}>
                {screen.steps.map((s, i) => <li key={i} style={{ marginBottom: 6 }}>{s[lang]}</li>)}
              </ol>
              <Descriptions size="small" column={1} bordered style={{ marginBottom: 12 }}>
                <Descriptions.Item label={L.enter}>{screen.enter[lang]}</Descriptions.Item>
                <Descriptions.Item label={L.approve}>{screen.approve[lang]}</Descriptions.Item>
              </Descriptions>
              {showFlow && (
                <Alert className="keep-tip" type="info" showIcon message={L.flow} style={{ marginBottom: 12 }}
                  description={<>{help._flow[lang]}<br /><a href="/help-videos/purchase-to-horse.mp4" target="_blank" rel="noreferrer"><PlayCircleOutlined /> {L.chain}</a></>} />
              )}
            </>
          )}
          <Paragraph type="secondary" style={{ fontSize: 12 }}>{help._tips[lang]}</Paragraph>
          <a href="/help/ASHR_User_Guide.docx"><FileWordOutlined /> {L.guide}</a>
        </div>
      </Drawer>
    </>
  );
};

export default HelpButton;
